var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 20.529,
    height: 19.601,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_9:_Winback",
    "data-name": "Stage 9: Winback",
    transform: "translate(-592.108 -304.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_688",
    "data-name": "Ellipse 688",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592.108 304.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32067",
    "data-name": "Group 32067",
    transform: "translate(595.844 308.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32066",
    "data-name": "Group 32066",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13536",
    "data-name": "Path 13536",
    d: "M14.188,3.54a1.641,1.641,0,0,1,1.463-1.321,4.205,4.205,0,0,1,1.669.732,4.191,4.191,0,0,1,1.667-.732A1.645,1.645,0,0,1,20.453,3.54c.158.582.4,2.641-3.09,4.681a.075.075,0,0,1-.044.012.086.086,0,0,1-.044-.012c-3.489-2.04-3.246-4.1-3.089-4.681M12.651,8.682a1.007,1.007,0,0,1,.9-.81,2.542,2.542,0,0,1,1.024.45,2.58,2.58,0,0,1,1.025-.45,1.009,1.009,0,0,1,.9.81c.1.357.246,1.622-1.9,2.874a.065.065,0,0,1-.027.008.05.05,0,0,1-.027-.008c-2.143-1.252-1.993-2.517-1.9-2.874M4.48.046A3.535,3.535,0,1,1,1.556,4.1,3.535,3.535,0,0,1,4.48.046h0M.627,19.547.553,13.581a16.01,16.01,0,0,0,3.273,3.97,1.612,1.612,0,0,0,1.163.393A21.245,21.245,0,0,0,8.3,17.419c.278-.068.776-.212,1.082-.3L9.416,19.6Zm7.587-2.716a21.2,21.2,0,0,1-3.246.518,1.257,1.257,0,0,1-.9-.3c-.42-.365-3.134-2.8-3.842-5.434C-.038,10.633-.169,9.271.4,8.582a2.214,2.214,0,0,1,1.51-.869l5.748-.032a.457.457,0,0,1,.074,0,3.23,3.23,0,0,1,1.93.675,6.429,6.429,0,0,1,2.2,3.54,7.172,7.172,0,0,1-2.187,1.33,10.23,10.23,0,0,1-.68-1.8L9.3,13.361a18.651,18.651,0,0,1-3.749.753,33.085,33.085,0,0,1-2.61-2.751l-.161.024a11.581,11.581,0,0,0,2.541,3.4c1.355-.156,5.044-.735,6.953-2.559a1.257,1.257,0,0,1,1.736,1.817,12.867,12.867,0,0,1-5.8,2.784m11.674-3.142a16.362,16.362,0,0,1-5.9,2.87,4.592,4.592,0,0,1-2.37.075,2.264,2.264,0,0,1-.327-.143,10.521,10.521,0,0,0,3.294-2.028,1.613,1.613,0,0,0,.477-.909A11.89,11.89,0,0,0,18.118,11.9a1.257,1.257,0,0,1,1.77,1.786",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinback);
export default __webpack_public_path__ + "static/media/winback.6cf666a373c0e3d953cceeb9d44d2525.svg";
export { ForwardRef as ReactComponent };